import { openNewTab } from "@/utils/browserUtils";

const SUPPORT_URL = "https://hub.smartwiz.ai/";
/**
 * Opens intercom but if something fails then fallback to the old support URL.
 */
export const openSupportTab = () => {
  openNewTab(SUPPORT_URL);
};
